import commercePopupTemplate from './templates/commerce.twig';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class Panel {
    constructor() {
        // close, header, content
        this.state = 'close';
        this.defDelay = 300;
        this.id = null;
    }

    /**
     * Открывает панель при клике на маркер.
     * @param {object} target - геообъект по которому произошло событие.
     */
    open(target) {
        this.data = target.options.get('data');
        this.template = target.options.get('template');
        // eslint-disable-next-line
        this.domTarget = target.getOverlaySync().getLayoutSync().getElement();
        this.marker = this.domTarget.querySelector('.j-yandex-map-marker');
        this.wrapper = target.getMap().container._element;
        this.fullscreenButton = this.wrapper.querySelector('.j-yandex-map__fullscreen-button');

        if (this.id === Number(this.data.id)) {
            // Если клик произошел потому же маркеру, то надо просто закрыть панельку.
            this._close();
        } else if (this.id !== Number(this.data.id) && this.state !== 'close') {
            // Если клик произошел по новому маркеру, но при этом панелька уже открыта, то нужно закрыть и открыть
            // новую с задержкой
            this._close();
            this._createTemplate('repeat');
        } else {
            this._createTemplate();
        }

        this._bindMapClickListener();
    }

    _bindMapClickListener() {
        window.addEventListener('bindMapClick', () => {
            this._close();
        });
    }

    /**
     * Создает шаблон панели.
     * @param {string} repeat - если клик произошел при уже открытой панельки, то это параметр показывает,
     * что нужно показать панельку с задержкой
     * @private
     */
    _createTemplate(repeat = '') {
        const noDelay = 0;
        const delay = repeat ? this.defDelay : noDelay;

        this._setStateMarker();

        setTimeout(() => {
            Utils.insetContent(this.wrapper, this.template(this.data));

            this.id = Number(this.data.id);

            this._getElements();
            this._bindEvents();
            this._showPanel();
        }, delay);
    }

    /**
     * Метод получает элементы панельки
     * @private
     */
    _getElements() {
        this.panel = this.wrapper.querySelector('.j-yandex-map-balloon');
        this.panelHeight = this.panel.offsetHeight;
    }

    // /**
    //  * Мето навешивает обработчики событий
    //  * @private
    //  */
    _bindEvents() {
        const closeButtons = Array.from(this.panel.querySelectorAll('.j-yandex-map-balloon-close'));
        const popupButton = this.panel.querySelector('.j-popup-marker');

        if (closeButtons.length) {
            closeButtons.forEach((close) => {
                close.addEventListener('click', () => {
                    this._close();
                });
            });
        }

        if (popupButton) {
            popupButton.addEventListener('click', () => {
                this.openPopup(popupButton);
            });
        }
    }

    openPopup(button) {
        const popup = document.querySelector('.j-map-popup');
        const dataAttributeJson = button.dataset.json;
        const dataJson = JSON.parse(Utils.fromBase64(dataAttributeJson));

        this._replaceContent(popup, commercePopupTemplate(dataJson.data.content));
        popup.classList.remove('is-active');
        popup.classList.add('is-active');
        this._closePopup();
        observer.publish('favorite:reInit');
        observer.publish('compare:reInit');
    }

    _closePopup() {
        const popup = document.querySelector('.j-map-popup');
        const popupClose = document.querySelector('.j-map-popup-close');

        popupClose.addEventListener('click', () => {
            popup.classList.remove('is-active');
        });
    }

    /**
     * Заменяет контент
     * @param {Node} element - элемент, контент которого будет заменен
     * @param {string} html - новый контент
     * @private
     */
    _replaceContent(element, html) {
        Utils.clearHtml(element);
        Utils.insetContent(element, html);
    }

    /**
     * Метод смещает кнопку раскрытия карты, чтобы панель не перекрывала её.
     * @param {number} height - высота панели
     * @private
     */
    _replaceFullscreenButton(height) {
        if (!this.fullscreenButton?.style) {
            return;
        }

        const staticIndentHeight = 30;

        this.fullscreenButton.style.bottom = `${height + staticIndentHeight}px`;
    }

    /**
     * Метод показывает только заголовок.
     * @private
     */
    _showPanel() {
        this._replaceFullscreenButton(this.panelHeight);
        this.panel.style.transform = `translateY(${this.panelHeight + 80}px)`;
        this.state = 'show';
        this.wrapper.classList.add('is-active');
    }

    /**
     * Метод скрывает всю панельку.
     * @private
     */
    _hideAll() {
        const start = 0;

        this._replaceFullscreenButton(start);
        this.panel.style.transform = `translateY(${start}px)`;
        this.state = 'close';
        this.wrapper.classList.remove('is-active');
    }

    /**
     * Метод удаляет панельку со страницы.
     * @private
     */
    _close() {
        this._removeStateMarker();
        this._hideAll();
        this.id = 'тест';

        setTimeout(() => {
            Utils.removeElement(this.panel);
        }, this.defDelay);
    }

    /**
     * Устанавливает активное состояние для маркера при клике на нем.
     * @private
     */
    _setStateMarker() {
        if (this.marker) {
            this.marker.classList.add('is-active');
        }
    }

    /**
     * Метод удаляет активное состояние у маркера.
     * @private
     */
    _removeStateMarker() {
        if (!this.marker) {
            return;
        }
        // Удаляем класс через querySelector, т.к при клике на другой маркер при активном текущем удаляется текущий,
        // а не предыдущий
        this.activeMarker = this.wrapper.querySelector('.j-yandex-map-marker.is-active');

        if (this.activeMarker) {
            this.activeMarker.classList.remove('is-active');
        }

        this.marker.classList.remove('is-active');
    }
}

export default Panel;
